export const isObjectsAssociationOptionsGroup = option => {
  return 'options' in option;
};